import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "ms-1" }
const _hoisted_8 = { class: "table" }
const _hoisted_9 = ["colspan"]
const _hoisted_10 = { class: "mb-0" }
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Suggested Production Countries Detail",
          text: "Suggested Production Countries Detail"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Provider:",
          text: "Provider:"
        }),
        _createElementVNode("strong", _hoisted_7, _toDisplayString(_ctx.providerName) + " - " + _toDisplayString(_ctx.providerPrice) + "€", 1)
      ]),
      _createElementVNode("table", _hoisted_8, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedProductionCountries, (phases, layer) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: layer }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  colspan: Object.keys(phases).length,
                  style: {"color":"#315498"}
                }, _toDisplayString(layer), 9, _hoisted_9)
              ]),
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phases, (countries, phase) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: phase,
                    style: {"font-size":"13px"}
                  }, _toDisplayString(phase), 1))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phases, (countries, phase) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: phase,
                    style: {"font-size":"14px"}
                  }, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(countries[0].country), 1),
                    (countries[0].providerName)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, "(" + _toDisplayString(countries[0].providerName) + " - " + _toDisplayString(countries[0].providerPrice) + "€)", 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ], 64))
          }), 128))
        ])
      ])
    ])
  ]))
}